<template lang="pug">
span#form_app(v-if="$route.fullPath !== '/'")
  router-view(v-slot="{ Component }")
    transition(name="fade")
      div(v-if="activated")
        component(v-if="ready", :is="Component" :pushToDataLayer="pushToDataLayer")
        Loader
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";

import Loader from "./components/global/Loader.vue";

export default {
  name: "UHCU Forms 2.0 - Loans",
  components: {
    Loader,
  },
  computed: {
    ...mapGetters(["activated", "ready", "title", "page"]),
  },
  methods: {
    ...mapMutations(["assignEndpoints"]),
    ...mapActions(["fetchData"]),
    pushToDataLayer(override) {
      if (override) {
        // console.log('-- form override --');
        // console.log(override);
      }

      const pageLogs = window.dataLayer.filter(
        (v) => v.event && v.event == "VirtualPageView"
      );
      const lastPageLog = pageLogs[pageLogs.length - 1];

      const slug =
        override && override.slug ? override.slug : this.$route.params.slug;

      if (lastPageLog && lastPageLog.virtualPageURL === `/${slug}`) return;

      const page = this.page(this.$route.params.slug);
      const navLabel =
        override && override.navLabel ? override.navLabel : page.navLabel;
      const step = override && override.step ? override.step : page.step;
      const stepName =
        override && override.stepName
          ? override.stepName
          : page.tracking_formStepName;

      const data = {
        event: "VirtualPageView",
        virtualPageURL: `/${slug}`,
        virtualPageTitle: `Step ${step} - ${navLabel} - ${this.title} | UHCU`,
        formName: this.title,
        formStepName: stepName || navLabel,
        formStepNumber: step,
        validationError: "",
      };
      //console.log(data);
      //console.log("DATALAYER -> event: VirtualPageView");
      window.dataLayer.push(data);
    },
    loadGoogleMapsAPI() {
      const script = document.createElement("script");
      let mapResolver, mapRejector;
      script.src = `https://maps.googleapis.com/maps/api/js?key=${this.$attrs.googleApi}&libraries=places&callback=initMap`;

      window.mapInitialized = new Promise((res, rej) => {
        mapResolver = res;
        mapRejector = rej;
      });
      window.initMap = function () {
        mapResolver();
      };
      document.body.appendChild(script);
    },
  },
  watch: {
    $route() {
      if (this.ready && this.$route.params.slug) {
        this.pushToDataLayer();
      }
    },
  },
  async created() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const query = Object.fromEntries(urlSearchParams.entries());

    if (this.$attrs.googleApi) this.loadGoogleMapsAPI();

    if (!window.dataLayer) window.dataLayer = [];
    this.$router.replace("/");

    this.assignEndpoints([this.$attrs.submit, this.$attrs.partialSubmit]);

    await this.fetchData({
      attrs: this.$attrs,
      router: this.$router,
      query,
    });

    const data = {
      event: "form_action",
      formStatus: "start",
      formName: this.title,
      formStepNumber: 1,
      formStepName: "Loan Details",
    };
    //console.log(data);
    //console.log("DATALAYER -> formStatus: start");
    window.dataLayer.push(data);
  },
};
</script>

<style lang="scss" scoped>
#form_app:deep(button) {
  &:focus {
    outline: none;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

div {
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 3rem 0;
}
</style>
